import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ValidationView = (props) => {
  const resultJson = useSelector((state) => state.FetchDataJson.JsonData);
  const lang = useSelector((state) => state.languageReducer.Language);
  console.log(props.ValidationList, "ValidatiossdsdnListValidationList");
  const navigate = useNavigate();
  console.log(props.ValidationList, "ValidationAllPageValidationAllPage");
  
  return (
    <>
    {
      resultJson?<>
       {props.ValidationAllPage == true ? (
        <>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              maxHeight: "600px",
              overflowY: "auto",
            }}
          >
            {props.ValidationMainList &&
              props.ValidationMainList.map((eleMain, ind) => {
                console.log(eleMain, "eleMaineleMain");

                return (
                  <>
                    <div
                      key={ind}
                      style={{ marginBottom: "15px", textAlign: "center" }}
                    >
                      <h3
                        onClick={() => {
                          navigate(`${"/ResearchersAward" + eleMain.urlPath}`);
                        }}
                        style={{
                          color: "#1890ff",
                          marginBottom: "10px",
                          cursor: "pointer",
                          fontFamily: "Tahoma, sans-serif",
                          fontWeight: "bold",
                          fontSize: "18px",
                          textDecoration: "underline",
                        }}
                      >
                        {lang === "en"
                          ? eleMain.sectionNameEn
                          : eleMain.sectionNameAr}
                      </h3>
                    </div>
                    {eleMain?.list.map((ele, ind) => (
                      <div
                        key={ind}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          background: "#f9f9f9",
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          padding: "12px",
                          marginBottom: "10px",
                          transition: "0.3s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f1faff")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "#f9f9f9")
                        }
                      >
                        {/* دائرة الأيقونة */}
                        <div
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            background: "#ff4d4f",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "10px",
                            marginLeft: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          !
                        </div>

                        {/* نص الرسالة */}
                        <p
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            color: "#333",
                            fontFamily: "Tahoma, sans-serif",
                          }}
                        >
                          {/* {resultJson[ele.code].nameAR +" : " + ele.validationMessage} */}
                          {lang === "en"
                            ? resultJson[ele.code] != undefined
                              ? resultJson[ele.code]?.nameEN +
                                " : " +
                                resultJson[ele.code]?.validateMessageEn
                              : ele.code + " : " + ele.message
                            : resultJson[ele.code] != undefined
                            ? resultJson[ele.code]?.nameAR +
                              " : " +
                              resultJson[ele.code]?.validateMessageAr
                            : ele.code + " : " + ele.message}
                        </p>
                      </div>
                    ))}
                  </>
                );
              })}
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              maxHeight: "600px",
              overflowY: "auto",
            }}
          >
            {props.ValidationList &&
              props.ValidationList.map((ele, ind) => (
                <div
                  key={ind}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "#f9f9f9",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "12px",
                    marginBottom: "10px",
                    transition: "0.3s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#f1faff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#f9f9f9")
                  }
                >
                  {/* دائرة الأيقونة */}
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      background: "#ff4d4f",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "10px",
                      marginLeft: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    !
                  </div>

                  {/* نص الرسالة */}
                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      color: "#333",
                      fontFamily: "Tahoma, sans-serif",
                    }}
                  >
                    {/* {resultJson[ele.code].nameAR +" : " + ele.validationMessage} */}
                    {lang === "en"
                      ? resultJson[ele.code] != undefined
                        ? resultJson[ele.code]?.nameEN +
                          " : " +
                          resultJson[ele.code]?.validateMessageEn
                        : ele.code + " : " + ele.message
                      : resultJson[ele.code] != undefined
                      ? resultJson[ele.code]?.nameAR +
                        " : " +
                        resultJson[ele.code]?.validateMessageAr
                      : ele.code + " : " + ele.message}
                  </p>
                </div>
              ))}
          </div>
        </>
      )}
      
      </>:<></>
    }
     
    </>
  );
};
export default ValidationView;
